export * from './revokeCredential';
